import React from 'react';
import { stats as defaultStats } from '../data/content';
import type { Stat } from '../data/content';
interface ProofBarProps {
  stats?: Stat[];
}
export function ProofBar({
  stats = defaultStats
}: ProofBarProps) {
  return <section className="w-full bg-blue-50 py-12 md:py-16" data-id="element-213" data-mp="7katj7vst7zb">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-214" data-mp="cjvt9kislkd3">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-215" data-mp="ci2j3v8z0i0c">
          {stats.map(stat => <div key={stat.label} data-id="element-216" data-mp="3us4rcvkidiei">
              <dt className="sr-only" data-id="element-217" data-mp="3jqwe4b864d6">{stat.label}</dt>
              <dd data-id="element-218" data-mp="3he5h1nhojnz">
                <span className="block text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl" data-id="element-219" data-mp="3krm19j2cp5o5">
                  {stat.value}
                </span>
                <span className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-220" data-mp="3pr76ucc10c9u">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}